import { TrimUiManager } from '../../ui/trim.ui.manager';
import { TrimPanZoomManager } from '../../pan-zoom/trim.pan-zoom.manager';
import { TrimEditableEvent } from '../trim.editable-event';
import { initPictureFlags, TrimImageController } from './trim.image-controller';
import { TrimFrameController } from '../frame/trim.frame-controller';
import { TrimEditableSideTool } from '../trim.editable-side-tool';
import { TrimImageEditableTool } from './trim.image-editable-tool';
import { TrimDataManager } from '../../data/trim-data.manager';
import * as createjs from 'createjs-module';
import { TrimCjBitmap, TrimCjContainer, TrimCjShape } from '../../../model/cj-factory';
import { CornerType, TrimCjCorner } from '../../../model/cj-factory/trim.cj-corner';
import { TrimCjTool } from '../../../../utilities/trim.cj-tool';
import { CJ_CONTAINER_NAME, CJ_DPOBJ_NAME, CJ_FOCUS_NAME } from '../../../model/cj-factory/trim.cj-obj-name.collection';
import { FocusModeType } from '../../data/trim-data-type';
import { TrimEditableImageManager } from '../../editable-image/trim.editable-image.manager';
import { FitChecker } from '../../../../utilities/fit-checker';
import { TrimEditableImage } from '../trim.editable-image';
import { TrimPosManager } from '../../pos/trim.pos.manager';
import { Pos } from '../../../../models/pos';
import { TrimImageEditManager } from '../trim.image-edit.manager';
import { TrimTextEvent } from '../text/trim.text-event';
import { TrimTrimmingManager } from '../../trimming/trim.trimming.manager';
import { cloneDeep } from 'lodash';

export type TargetType = {
  id: string,
  photoId: string,
  pos: { x: number, y: number },
  scale: { x: number, y: number },
  reg: { x: number, y: number },
  rotation: number,
}

export class TrimImageEvent {
  private stage: TrimCjContainer;

  private editableImageManager!: TrimEditableImageManager;
  private panZoomManager!: TrimPanZoomManager;
  private imageController!: TrimImageController;
  private frameController!: TrimFrameController;
  private editableEvent!: TrimEditableEvent;
  private editableSideTool!: TrimEditableSideTool;
  private imageEditableTool!: TrimImageEditableTool;
  private trimDataManager!: TrimDataManager;
  private posManager!: TrimPosManager;
  private imageEditManager!: TrimImageEditManager;
  private textEvent!: TrimTextEvent;
  private trimmingManager!: TrimTrimmingManager;

  private clicked: boolean = false;
  private transformed: boolean = false;
  activeFocus: TrimCjContainer | null = null;
  targetFrame: TrimCjContainer | null = null;
  isFocus: boolean = false;
  isExchange: boolean = false;
  isSelect: boolean = true;
  isMove: boolean = false;
  private isFastMove: boolean = true;
  private showToolTip: boolean = false;
  private checkCounter: number = 0;
  private delayNum: number = 2;
  frameMoveMode: boolean = true;
  corner: TrimCjCorner | null = null;
  dragTarget: TrimCjContainer | null = null;
  private dragPointX: number = 0;
  private dragPointY: number = 0;
  private cornerType: 'lt' | 'rt' | 'rb' | 'lb' = 'lt';
  private movingTarget: TrimCjContainer | null = null;
  private previewImage: createjs.Bitmap | null = null;
  private timerId: NodeJS.Timeout | undefined;

  targetData: TargetType = {
    id: '',
    photoId: '',
    pos: { x: 0, y: 0 },
    scale: { x: 0, y: 0 },
    reg: { x: 0, y: 0 },
    rotation: 0,
  };
  targetDataFitBef: TargetType = {
    id: '',
    photoId: '',
    pos: { x: 0, y: 0 },
    scale: { x: 0, y: 0 },
    reg: { x: 0, y: 0 },
    rotation: 0,
  };
  private prevRotate: number = 0;

  imageInitData: {
    target: TrimCjContainer,
    param: {
      x: number,
      y: number,
      movePos: { x: number, y: number },
      rotation: number,
      scaleX: number,
      scaleY: number,
      regX: number,
      regY: number,
    },
  }[] = [];

  constructor(stage: TrimCjContainer) {
    this.stage = stage;
  }

  di(
    imageController: TrimImageController,
    frameController: TrimFrameController,
    panZoomMng: TrimPanZoomManager,
    editableEvent: TrimEditableEvent,
    editableSideTool: TrimEditableSideTool,
    imageEditableTool: TrimImageEditableTool,
    layoutDataManager: TrimDataManager,
    editableMng: TrimEditableImageManager,
    posMng: TrimPosManager,
    imageEditMng: TrimImageEditManager,
    textEvent: TrimTextEvent,
    trimmingMng: TrimTrimmingManager,
  ): void {
    this.frameController = frameController;
    this.imageController = imageController;
    this.panZoomManager = panZoomMng;
    this.editableEvent = editableEvent;
    this.editableSideTool = editableSideTool;
    this.imageEditableTool = imageEditableTool;
    this.trimDataManager = layoutDataManager;
    this.editableImageManager = editableMng;
    this.posManager = posMng;
    this.imageEditManager = imageEditMng;
    this.textEvent = textEvent;
    this.trimmingManager = trimmingMng;
  }

  initialize() {
  }

  destroy() {
    this.clicked = false;
    this.transformed = false;
    this.activeFocus = null;
    this.targetFrame = null;
    this.isFocus = false;
    this.isFastMove = true;
    this.isMove = false;
    this.frameMoveMode = true;
    this.corner = null;
    this.dragPointX = 0;
    this.dragPointY = 0;
    this.cornerType = 'lt';
    this.movingTarget = null;
    this.previewImage = null;
    this.imageInitData.length = 0;
  }

  update(stage: TrimCjContainer): void {
    this.stage = stage;
  }

  // - 選択時の枠の四隅のアイコン作成 -
  async createCorner(
    imageBounds: createjs.Rectangle,
    type: FocusModeType,
  ): Promise<(TrimCjCorner | TrimCjShape)[]> {
    return new Promise((resolve) => {
      const Icons = [];
      if (type === 'scale') {
        Icons.push(new TrimCjCorner('scale', 'rt', imageBounds));
        Icons.push(new TrimCjCorner('scale', 'rb', imageBounds));
        Icons.push(new TrimCjCorner('scale', 'lb', imageBounds));
        Icons.push(new TrimCjCorner('scale', 'lt', imageBounds));
      } else if (type === 'rotate' || type === 'png') {
        Icons.push(new TrimCjCorner('scale', 'rt', imageBounds));
        Icons.push(new TrimCjCorner('rotate', 'rb', imageBounds));
        Icons.push(new TrimCjCorner('scale', 'lb', imageBounds));
        Icons.push(new TrimCjCorner('rotate', 'lt', imageBounds));
      } else {
        const corner: TrimCjShape = new TrimCjShape();
        corner.graphics.f('#A5B9F4').dc(imageBounds.x + imageBounds.width, imageBounds.y, 5);
        corner.graphics.f('#A5B9F4').dc(imageBounds.x + imageBounds.width, imageBounds.y + imageBounds.height, 5);
        corner.graphics.f('#A5B9F4').dc(imageBounds.x, imageBounds.y + imageBounds.height, 5);
        corner.graphics.f('#A5B9F4').dc(imageBounds.x, imageBounds.y, 5);
        Icons.push(corner);
      }
      for (const icon of Icons) {
        icon.name = CJ_FOCUS_NAME.corner;
      }
      resolve(Icons);
    });
  }

  // - 選択時の枠作成 -
  async createFocus(image: TrimCjContainer, focusMode: FocusModeType) {
    let imageBounds = image.getBounds();
    // -- コンテナとシェイプ用意 --
    const container: TrimCjContainer = new TrimCjContainer();
    switch (focusMode) {
      case 'scale':
        container.name = CJ_CONTAINER_NAME.focus.scale;
        break;
      case 'rotate':
        const photo = await TrimCjTool.checkLoad(image.getChildByName(CJ_DPOBJ_NAME.image) as TrimCjBitmap);
        imageBounds = photo.getTransformedBounds();
        container.name = CJ_CONTAINER_NAME.focus.rotate;
        break;
      case 'png':
        container.name = CJ_CONTAINER_NAME.focus.rotate;
        break;
      case 'move' || 'none':
        container.name = CJ_CONTAINER_NAME.focus.move;
        break;
      default:
        break;
    }
    const focus: TrimCjShape = new TrimCjShape();
    focus.name = CJ_FOCUS_NAME.line;
    // -- 四隅にアイコン設置（右上、右下、左下、左上の順） --
    container.addChild(focus);
    if (focusMode === 'scale' || focusMode === 'rotate' || focusMode === 'png') {
      focus.graphics.s('#A5B9F4');
      focus.graphics.ss(3.5);
      focus.graphics.dr(imageBounds.x, imageBounds.y, imageBounds.width, imageBounds.height);
    } else {
      focus.graphics.s('#A5B9F4');
      focus.graphics.sd([10, 5], 0);
      focus.graphics.dr(imageBounds.x, imageBounds.y, imageBounds.width, imageBounds.height);
    }
    const corners = await this.createCorner(imageBounds, focusMode);
    for (const _corner of corners) {
      if (focusMode === 'move') {
        container.addChild(_corner);
      } else {
        const corner = _corner as TrimCjCorner;
        corner.on('mousedown', (e: any) => {
          this.handleTransformStart(image, e);
        });
        if ((focusMode === 'rotate' && (corner.position === 'lt' || corner.position === 'rb'))
          || (focusMode === 'png' && (corner.position === 'lt' || corner.position === 'rb'))) {
          corner.on('pressmove', (e: any) => {
            this.handleRotateMove(image, e, corner.position);
          });
          corner.on('mouseover', (e: any) => {
            if (this.showToolTip) return;
            this.showToolTip = true;
            const pos = this.posManager.canvasToBrowser({
              // container の外側の座標だから container の座標を引いとく
              x: this.stage.stage.mouseX - TrimImageEditManager.STAGE_CONTAINER_X + 10,
              y: this.stage.stage.mouseY - TrimImageEditManager.STAGE_CONTAINER_Y + 10,
            });
            TrimUiManager.ins.emit('t->r:show-tooltip',
              { type: 'rotateIcon', pos },
            );
          });
          corner.on('mouseout', (e) => {
            this.showToolTip = false;
            TrimUiManager.ins.emit('t->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
          });
        } else {
          corner.on('pressmove', (e: any) => {
            this.handleScaleMove(image, e);
          });
          corner.on('mouseover', (e) => {
            if (this.showToolTip) return;
            this.showToolTip = true;
            const pos = this.posManager.canvasToBrowser({
              // container の外側の座標だから container の座標を引いとく
              x: this.stage.stage.mouseX - TrimImageEditManager.STAGE_CONTAINER_X + 10,
              y: this.stage.stage.mouseY - TrimImageEditManager.STAGE_CONTAINER_Y + 10,
            });
            TrimUiManager.ins.emit('t->r:show-tooltip',
              { type: 'scaleIcon', pos },
            );
          });
          corner.on('mouseout', (e) => {
            this.showToolTip = false;
            TrimUiManager.ins.emit('t->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
          });
        }
        corner.on('pressup', (e: any) => {
          this.handleTransformEnd(image, e);
        });
        container.addChild(corner);
      }
    }
    if (focusMode === 'png') {
      const deleteIcon = new TrimCjCorner('delete', 'ct', imageBounds);
      deleteIcon.name = CJ_FOCUS_NAME.delete;
      deleteIcon.on('pressup', (e: any) => {
        console.log('delete !!!!!!!');
        TrimUiManager.ins.emit('r->t:delete');
      })
      container.addChild(deleteIcon);
    }
    return container;
  }

  updateToolPos(focusMode: FocusModeType, target: TrimCjContainer) {
    const isPng = this.trimDataManager.getFocusMode() === 'png';
    if (isPng) return;
    const defaultContainer = TrimCjTool.getDefaultContainer(target);
    const imageAreaContainer = TrimCjTool.getImageAreaContainer(target);
    const photoContainer = TrimCjTool.getPhotoContainer(target);
    const scaleContainer = TrimCjTool.getScaleContainer(target);
    const rotateContainer = TrimCjTool.getRotateContainer(target);
    const defaultData = defaultContainer.getTransformedBounds();
    const isPhoto = TrimCjTool.checkPhotoInFrame(target);
    const imageContainerData = (focusMode === 'rotate' || focusMode === 'dai') ? imageAreaContainer.getBounds() : undefined;
    const imageContainerTfData = (focusMode === 'rotate' || focusMode === 'dai') ? imageAreaContainer.getTransformedBounds() : undefined;
    const photoContainerData = (focusMode === 'rotate' || focusMode === 'dai') ? photoContainer.getBounds() : undefined;
    const photoContainerTfData = (focusMode === 'rotate' || focusMode === 'dai') ? photoContainer.getTransformedBounds() : undefined;
    const diffFramePos = {
      x: photoContainerTfData ? ((photoContainerTfData.width * scaleContainer.scaleX) - photoContainerTfData.width) / 2 : 0,
      y: photoContainerTfData ? ((photoContainerTfData.height * scaleContainer.scaleX) - photoContainerTfData.height) / 2 : 0,
    };
    if (TrimCjTool.checkPhotoInFrame(target)) {
      photoContainer.rotation = rotateContainer.isRotate
        ? photoContainer.rotation + 90
        : photoContainer.rotation;
    }
    const framePos = TrimCjTool.getFramePos(target);
    let pos: Pos = this.posManager.canvasToBrowser({
      x: (focusMode === 'rotate' || focusMode === 'dai')
        ? imageContainerData!.x + (photoContainerTfData!.x - photoContainer.movePos.x) + imageAreaContainer.movePos.x + (photoContainer.movePos.x * scaleContainer.scaleX) - diffFramePos.x - framePos.x
        : defaultData.x,
      y: (focusMode === 'rotate' || focusMode === 'dai')
        ? imageContainerData!.y - 30 + (photoContainerTfData!.y - photoContainer.movePos.y) + imageAreaContainer.movePos.y + (photoContainer.movePos.y * scaleContainer.scaleX) - diffFramePos.y - framePos.y
        : defaultData.y - 30,
    });
    // 写真枠が回転している場合
    if (focusMode === 'rotate' && rotateContainer.isRotate) {
      pos = this.posManager.canvasToBrowser({
        x: imageContainerData!.x + (photoContainerTfData!.y - photoContainer.movePos.y) - imageAreaContainer.movePos.y - (photoContainer.movePos.y * scaleContainer.scaleX) - diffFramePos.y + framePos.y,
        y: imageContainerData!.y + (photoContainerTfData!.x - photoContainer.movePos.x) + imageAreaContainer.movePos.x + (photoContainer.movePos.x * scaleContainer.scaleX) - diffFramePos.x - framePos.x,
      });
    }
    if (TrimCjTool.checkPhotoInFrame(target)) {
      photoContainer.rotation = rotateContainer.isRotate
        ? photoContainer.rotation - 90
        : photoContainer.rotation;
    }
    TrimUiManager.ins.emit('t->r:select', {
      image: target,
      pos,
      isImgDisabled: focusMode === 'dai' || imageAreaContainer.logoFlag ? true : !Boolean(isPhoto),
    });
  }

  // -- containerのfocus --
  handleFocus(target: TrimCjContainer, focusMode: FocusModeType) {
    // --- すでに表示されているfocusの削除 ---
    this.trimDataManager.setFocusMode(focusMode)
    if (this.textEvent.isFocus && this.textEvent.targetFrame) {
      this.editableEvent.disFocused(this.textEvent.targetFrame);
    }
    if (target !== this.targetFrame) {
      TrimUiManager.ins.emit('t->r:dis-select');
      if (this.targetFrame) {
        this.editableEvent.disFocused(this.targetFrame);
      }
    }
    this.isFocus = true;
    this.targetFrame = target;
    const rotateContainer = TrimCjTool.getRotateContainer(target);
    const rotateLength = rotateContainer.numChildren;
    let focus;
    switch (focusMode) {
      case 'scale':
        focus = TrimCjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.scale);
        focus.visible = true;
        TrimUiManager.ins.emit('t->r:change-image/frame', { mode: 'image-frame' });
        const imageArea = TrimCjTool.getImageAreaContainer(target);
        imageArea && rotateContainer.setChildIndex(imageArea, rotateLength - 1);
        break;
      case 'rotate':
      case 'dai' :
        focus = TrimCjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.rotate);
        focus.visible = true;
        TrimUiManager.ins.emit('t->r:change-image/frame', { mode: 'image' });
        const image = TrimCjTool.getImageContainer(target);
        image && rotateContainer.setChildIndex(image, rotateLength - 1);
        break;
      // case 'dai':
      //   focus = CjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.rotate);
      //   focus.visible = true;
      //   TrimUiManager.ins.emit('t->r:change-image/frame', { mode: 'image' });
      //   const imageDai = CjTool.getImageContainer(target);
      //   imageDai && rotateContainer.setChildIndex(imageDai, rotateLength - 1);
      //   break;
      case 'move':
      case 'none':
        focus = TrimCjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.move);
        focus.visible = true;
        break;
      default:
        break;
    }
    this.activeFocus = focus ?? null;
    const editablePhoto = TrimCjTool.getDefaultContainer(target);
    const frameLength = this.stage.numChildren;
    editablePhoto && this.stage.setChildIndex(editablePhoto, frameLength - 1);
    const imaContainer = TrimCjTool.getImageAreaContainer(target);
    const imaData = TrimCjTool.getImageAreaContainer(target).getTransformedBounds();
    // 写真枠移動のときのツールチップ表示
    const pos = this.posManager.canvasToBrowser({
      // container の外側の座標だから container の座標を引いとく
      x: imaData.x + imaData.width / 2 - 86 + imaContainer.movePos.x,
      y: imaData.y + imaData.height + imaContainer.movePos.y + 10,
    });
    if (focusMode === 'move') {
      TrimUiManager.ins.emit('t->r:show-tooltip', {
        type: 'frameMove',
        pos,
      });
    }
    // --- ツールメニューの表示 ---
    this.updateToolPos(focusMode, target);
    // this.stage.stage.getChildByName(CJ_CONTAINER_NAME.baseMask).visible = false;
  }

  // -- PNG画像のフォーカス --
  handlePngFocus(target: TrimCjContainer) {
    if (target !== this.targetFrame || this.textEvent.targetFrame) {
      TrimUiManager.ins.emit('t->r:dis-select');
      this.editableEvent.disFocused(this.targetFrame!);
      this.textEvent.targetFrame && this.editableEvent.disFocused(this.textEvent.targetFrame);
    }
    // --- すでに表示されているfocusの削除 ---
    TrimUiManager.ins.emit('t->r:dis-select');
    const targetData = target.getTransformedBounds();
    // --- ツールメニューの表示 ---
    const pos: Pos = this.posManager.canvasToBrowser({
      x: targetData.x,
      y: targetData.y - 30,
    });
    TrimCjTool.checkLoad(target).then((v) => {
      TrimUiManager.ins.emit('t->r:select', {
        image: v,
        pos,
        isImgDisabled: true,
      });
    }).finally(() => {
      this.targetFrame = target;
      let focus = target.getChildByName(CJ_CONTAINER_NAME.focus.rotate) as TrimCjContainer;
      focus.visible = true;
      this.trimDataManager.setFocusMode('png')
      TrimUiManager.ins.emit('t->r:change-image/frame', { mode: 'image' });
      this.activeFocus = focus ?? null;
      const frameLength = this.stage.numChildren;
      target && this.stage.setChildIndex(target, frameLength - 1);
    });
  }

  // -- 移動開始 --
  handleMoveStart(target: TrimCjContainer, e: any, isPng?: boolean) {
    if (this.transformed) return;
    const mouseX = Math.round(e.stageX - TrimImageEditManager.STAGE_CONTAINER_X);
    const mouseY = Math.round(e.stageY - TrimImageEditManager.STAGE_CONTAINER_Y);
    this.dragPointX = mouseX;
    this.dragPointY = mouseY;
    TrimUiManager.ins.emit('t->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
    // --- pngの移動 ---
    if (isPng) {
      // --- drag地点の保持 ---
      // --- Redo用移動前座標の保持 ---
      this.targetData.pos = { x: target.x, y: target.y };
      this.targetDataFitBef.pos = { x: target.x, y: target.y };
      return;
    }
    const focusMode = this.trimDataManager.getFocusMode();
    // --- 写真入れ替えモード ---
    if (focusMode === 'rotate' || focusMode === 'dai' && this.activeFocus) {
      if (!TrimCjTool.checkPhotoInFrame(target)) return;
      const photo = TrimCjTool.getPhotoContainer(target);
      // --- Redo用移動前座標の保持 ---
      this.targetData.pos = { x: Math.round(photo.x), y: Math.round(photo.y) };
      this.targetDataFitBef.pos = { x: Math.round(photo.x), y: Math.round(photo.y) };
    } else if (this.activeFocus) {
      // --- drag地点の保持 ---
      this.dragPointX -= target.x;
      this.dragPointY -= target.y;
      // --- Redo用移動前座標の保持 ---
      this.targetData.pos = { x: target.x, y: target.y };
      this.targetDataFitBef.pos = { x: target.x, y: target.y };
    }
    // 動かすときにはツールチップ非表示
    TrimUiManager.ins.emit('t->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
  }

  // -- containerの移動 --
  handleMove(target: TrimCjContainer, e: any, isPng?: boolean) {
    if (this.transformed) return;
    this.checkCounter++;
    this.isMove = true;
    this.dragTarget = target;
    const mouseX = Math.round(e.stageX - TrimImageEditManager.STAGE_CONTAINER_X);
    const mouseY = Math.round(e.stageY - TrimImageEditManager.STAGE_CONTAINER_Y);
    if (isPng) {
      target.x = this.targetData.pos.x + (mouseX - this.dragPointX);
      target.y = this.targetData.pos.y + (mouseY - this.dragPointY);
      return;
    }
    const focusMode = this.trimDataManager.getFocusMode();

    // --- 写真の移動 ---
    if ((focusMode === 'rotate' || focusMode === 'dai') && this.activeFocus) {
      if (!TrimCjTool.checkPhotoInFrame(target)) return;
      const photo = TrimCjTool.getPhotoContainer(target);
      const scaleContainer = TrimCjTool.getScaleContainer(target);
      const rotateContainer = TrimCjTool.getRotateContainer(target);
      const prevPhoto = cloneDeep(photo);
      if (!rotateContainer.isRotate) {
        photo.x = this.targetData.pos.x + ((mouseX - this.dragPointX) / scaleContainer.scaleX);
        photo.y = this.targetData.pos.y + ((mouseY - this.dragPointY) / scaleContainer.scaleY);
      } else {
        photo.x = this.targetData.pos.x + ((mouseY - this.dragPointY) / scaleContainer.scaleY);
        photo.y = this.targetData.pos.y - ((mouseX - this.dragPointX) / scaleContainer.scaleX);
      }
      // photo.x = pos.x;
      // photo.y = pos.y;

        // if (!(this.checkCounter % this.delayNum)) {
      const isToast = FitChecker.checkImageOneOutBounds(photo, !this.imageEditManager.printMenu.isAllowMargin);
      if (this.imageEditManager.printMenu.isAllowMargin) {
        this.imageEditManager.isFit = isToast;
        TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
      }
      if (isToast && !this.imageEditManager.printMenu.isAllowMargin) {
        const _pos = FitChecker.findClosestValidPosition(photo, {x: prevPhoto.x, y: prevPhoto.y}, {x: photo.x, y: photo.y});
        photo.x = _pos.x;
        photo.y = _pos.y;
        this.dragPointX = mouseX;
        this.dragPointY = mouseY;
        this.targetData.pos = { x: Math.round(_pos.x), y: Math.round(_pos.y) };
      }
        // }



      // if (!(this.checkCounter % this.delayNum)) {
      //   const photoFrames: [] = this.layoutDataManager.selector('getEditors', photo.pageId);
      //   const isToast = FitChecker.checkImageOneOutBounds(photo);
      //   this.imageEditManager.isFit = isToast;
      //   TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
      // }
    } else if (focusMode === 'move' && this.activeFocus) {
      target.x = mouseX - this.dragPointX;
      target.y = mouseY - this.dragPointY;
    }
  }

  // -- containerの移動end --
  handleMoveEnd(container: TrimCjContainer, e: any, isPng?: boolean) {
    const photo = TrimCjTool.getPhotoContainer(container);
    const isToast = FitChecker.checkImageOneOutBounds(photo, !this.imageEditManager.printMenu.isAllowMargin);
    if (isToast && !this.imageEditManager.printMenu.isAllowMargin) {
      const _pos = FitChecker.findClosestValidPosition(photo, {x: photo.defaultPos.x, y: photo.defaultPos.y}, {x: photo.x, y: photo.y});
      photo.x = _pos.x;
      photo.y = _pos.y;
      this.targetData.pos = { x: Math.round(_pos.x), y: Math.round(_pos.y) };
    }
    if (!container || this.transformed || !this.isMove) {
      this.isExchange = false;
      this.isMove = false;
      this.dragTarget = null;
      this.checkCounter = 0;
      return;
    }
    this.isExchange = false;
    this.isMove = false;
    this.dragTarget = null;
    this.checkCounter = 0;
    const focusMode = this.trimDataManager.getFocusMode();
    switch (container.name) {
      case CJ_CONTAINER_NAME.editor:
        const guid = TrimCjTool.getGuidContainer(this.stage);
        if (!guid) break;
        if (!TrimCjTool.hitTest(container, guid)) {

          const targetBef = this.targetDataFitBef.pos;
          const leftBef = Math.round(targetBef.x);
          const topBef = Math.round(targetBef.y);
          const targetAf = container;
          const leftAf = Math.round(targetAf.x);
          const topAf = Math.round(targetAf.y);

          if (container) {
            container.x = leftBef;
            container.y = topBef;
            container.movePos.x -= leftAf - leftBef;
            container.movePos.y -= topAf - topBef;
          }
          return;
        }
        break;
      default:
        break;
    }
    // --- 写真入れ替えモード完了 ---
    if (this.previewImage) {
      this.stage.removeChild(this.previewImage);
      this.previewImage = null;
      this.isFastMove = true;
    }
    if (!this.activeFocus && focusMode !== 'dai') {
      const targetFrame: TrimCjContainer = this.trimDataManager.getImageArea();
      TrimCjTool.getHighlight(targetFrame).visible = false;
      targetFrame.isChecked = false;
      const imageBox: { image: TrimEditableImage, target: TrimCjContainer }[] = [];
      if (!targetFrame || !this.movingTarget) return;
      const targetContainer = TrimCjTool.getScaleContainer(targetFrame);
      // ---- ドラッグ地点の画像 ----
      const isPhotoA = TrimCjTool.checkPhotoInFrame(this.movingTarget);
      // ---- ドロップ地点の画像 ----
      const isPhotoB = TrimCjTool.checkPhotoInFrame(targetContainer);
      if (this.movingTarget.photoAreaId === targetContainer.photoAreaId || !isPhotoA) return;
      // ---- ドローワーに追加済みの画像リスト ----
      const editableList = this.editableImageManager.list;
      // ---- ドラッグ地点 ----
      const photoContainerA = TrimCjTool.getPhotoContainer(this.movingTarget);
      const photoA = editableList.find((v) => v.id === photoContainerA.editableImageId);
      imageBox.push({ image: photoA!, target: targetContainer });
      // ---- ドロップ地点 ----
      const photoContainerB = TrimCjTool.getPhotoContainer(targetContainer);
      if (isPhotoB) {
        this.isExchange = true;
        const photoB = editableList.find((v) => v.id === photoContainerB.editableImageId);
        imageBox.push({ image: photoB!, target: this.movingTarget });
        const imageAreaA = TrimCjTool.getImageAreaContainer(imageBox[0].target);
        const imageAreaB = TrimCjTool.getImageAreaContainer(imageBox[1].target);
        if (imageAreaA.logoFlag !== imageAreaB.logoFlag) {
          TrimUiManager.ins.emit('t->r:push-dialog', {
            title: '確認',
            message: [
              `写真枠とロゴ枠の画像の入れ替えはできません。`,
              `それぞれの枠に個別に画像をドラッグドロップして配置してください。`,
            ],
            buttons: [
              {
                label: 'OK',
                callback: () => {
                  const highlightA = TrimCjTool.getHighlight(imageAreaA);
                  const highlightB = TrimCjTool.getHighlight(imageAreaB);
                  highlightA && (highlightA.visible = false);
                  highlightB && (highlightB.visible = false);
                },
              },
            ],
          });
          return;
        }
        this.editableEvent.action(
          'exchange',
          `${imageBox[0].image}と${imageBox[1].image}を交換`,
          () => {
            for (let i = 0; i < imageBox.length; i++) {
              this.imageController.createPhotoImage(imageBox[i].image, imageBox[i].target);
            }
          },
          () => {
            this.imageController.createPhotoImage(imageBox[0].image, imageBox[1].target);
            this.imageController.createPhotoImage(imageBox[1].image, imageBox[0].target);
          },
        );
      } else {
        this.isExchange = true;
        const nowImageArea = TrimCjTool.getImageAreaContainer(this.movingTarget);
        const nextImageArea = TrimCjTool.getImageAreaContainer(targetContainer);
        if (nowImageArea.logoFlag !== nextImageArea.logoFlag) {
          TrimUiManager.ins.emit('t->r:push-dialog', {
            title: '確認',
            message: [
              `写真枠とロゴ枠の画像の入れ替えはできません。`,
              `それぞれの枠に個別に画像をドラッグドロップして配置してください。`,
            ],
            buttons: [
              {
                label: 'OK',
                callback: () => {
                  const highlightA = TrimCjTool.getHighlight(nowImageArea);
                  const highlightB = TrimCjTool.getHighlight(nextImageArea);
                  highlightA && (highlightA.visible = false);
                  highlightB && (highlightB.visible = false);
                },
              },
            ],
          });
          return;
        }
        this.editableEvent.action(
          'exchange',
          `${imageBox[0].image}を移動`,
          () => {
            const container = TrimCjTool.getRotateContainer(this.movingTarget!);
            const imgContainer = TrimCjTool.getImageContainer(this.movingTarget!);
            TrimCjTool.getMaskContainer(container).alpha = 1;
            // this.layoutDataManager.dispatch('removeImage', imgContainer);
            container.removeChild(imgContainer);
            this.imageController.createPhotoImage(photoA!, targetContainer);
          },
          () => {
            const container = TrimCjTool.getRotateContainer(targetContainer);
            const imgContainer = TrimCjTool.getImageContainer(targetContainer);
            TrimCjTool.getMaskContainer(container).alpha = 1;
            // this.layoutDataManager.dispatch('removeImage', imgContainer);
            container.removeChild(imgContainer);
            this.imageController.createPhotoImage(photoA!, this.movingTarget!);
          },
        );

      }
      return;
    }
    if ((focusMode === 'rotate' || focusMode === 'dai') && !TrimCjTool.checkPhotoInFrame(container)) return;
    // --- ターゲット指定 ---
    const target = (focusMode === 'rotate' || focusMode === 'dai')
      ? TrimCjTool.getPhotoContainer(container)
      : container;
    // --- Redo ---
    const targetBef = this.targetDataFitBef.pos;
    const leftBef = targetBef.x;
    const topBef = targetBef.y;
    // --- Undo ---
    const targetAf = target;
    const leftAf = targetAf.x;
    const topAf = targetAf.y;
    // --- movePos ---
    const movePos = focusMode === 'move'
      ? TrimCjTool.getImageAreaContainer(target).movePos
      : target.movePos;
    const prevBase = (focusMode === 'rotate' || focusMode === 'dai')
      ? TrimCjTool.getDefaultContainer(target)
      : target;
    // --- fire ---
    this.editableEvent.action(
      'move',
      `left: ${leftBef} → ${leftAf}, top: ${topBef} → ${topAf} に移動`,
      () => {
        let prevTarget;
        if (target) {
          if (!this.isFocus) {
            const isPng = focusMode === 'png';
            if (isPng || focusMode !== 'move') {
              this.imageEditableTool.imageMode(prevBase, isPng);
            }
          }
          prevTarget = (focusMode === 'rotate' || focusMode === 'dai')
            ? TrimCjTool.getPhotoContainer(prevBase)
            : prevBase;
          prevTarget.x = leftAf;
          prevTarget.y = topAf;
          movePos.x += leftAf - leftBef;
          movePos.y += topAf - topBef;
          if (focusMode === 'rotate' || focusMode === 'dai') {
            if (!(this.checkCounter % this.delayNum)) {
              const isToast = FitChecker.checkImageOneOutBounds(prevTarget);
              this.imageEditManager.isFit = isToast;
              TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
            }
          }
        }
      },
      () => {
        let prevTarget;
        if (!this.isFocus) {
          const isPng = focusMode === 'png';
          if (isPng || focusMode !== 'move') {
            this.imageEditableTool.imageMode(prevBase, isPng);
          }
        }
        prevTarget = (focusMode === 'rotate' || focusMode === 'dai')
          ? TrimCjTool.getPhotoContainer(prevBase)
          : prevBase;
        if (target) {
          prevTarget.x = leftBef;
          prevTarget.y = topBef;
          movePos.x -= leftAf - leftBef;
          movePos.y -= topAf - topBef;
          if (focusMode === 'rotate' || focusMode === 'dai') {
            if (!(this.checkCounter % this.delayNum)) {
              const isToast = FitChecker.checkImageOneOutBounds(prevTarget);
              this.imageEditManager.isFit = isToast;
              TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
            }
          }
        }
      },
    );
    const containerData = container.getTransformedBounds();
    const pos = this.posManager.canvasToBrowser({
      // container の外側の座標だから container の座標を引いとく
      x: containerData.x + containerData.width / 2 - 86 + container.movePos.x,
      y: containerData.y + containerData.height + container.movePos.y + 10,
    });
    if (focusMode === 'move') {
      TrimUiManager.ins.emit('t->r:show-tooltip', {
        type: 'frameMove',
        pos,
      });
    } else {
      this.updateToolPos(focusMode, target);
    }
  }

  // -- containerの拡縮start --
  handleTransformStart(target: TrimCjContainer, e: any) {
    this.transformed = true;
    const focusMode = this.trimDataManager.getFocusMode();
    // --- drag地点の保持 ---
    const mouseX = Math.round(e.stageX - TrimImageEditManager.STAGE_CONTAINER_X);
    const mouseY = Math.round(e.stageY - TrimImageEditManager.STAGE_CONTAINER_Y);
    this.dragPointX = Math.round(mouseX);
    this.dragPointY = Math.round(mouseY);

    // --- コンテナ用意 ---
    let container;
    let area;
    let pointA;
    let pointB;
    let pointC;
    // ---クリック地点の角度算出 A:起点(枠の半分, 0) B:中心点（枠の半分, 枠の半分） C:クリック地点 ---
    if (focusMode === 'rotate' || focusMode === 'dai') {
      container = TrimCjTool.getPhotoContainer(target);
      area = TrimCjTool.getImageAreaContainer(target);
      const scaleContainer = TrimCjTool.getScaleContainer(target);
      const areaData = area.getBounds();
      pointA = {
        x: areaData.x + areaData.width / 2 + (container.movePos.x * scaleContainer.scaleX) + area.movePos.x,
        y: (container.movePos.y * scaleContainer.scaleX) + area.movePos.y,
      };
      pointB = {
        x: areaData.x + areaData.width / 2 + (container.movePos.x * scaleContainer.scaleX) + area.movePos.x,
        y: areaData.y + areaData.height / 2 + (container.movePos.y * scaleContainer.scaleX) + area.movePos.y,
      };
      pointC = { x: mouseX, y: mouseY };

      if (!TrimCjTool.checkPhotoInFrame(target)) return;
      const photoContainer = TrimCjTool.getPhotoContainer(target);
      // --- Redo用移動前座標の保持 ---
      this.targetData.rotation = photoContainer.rotation;
      this.targetData.pos = { x: photoContainer.x, y: photoContainer.y };
      this.targetData.scale = { x: photoContainer.scaleX, y: photoContainer.scaleY };
      this.targetData.reg = { x: photoContainer.regX, y: photoContainer.regY };
      this.targetDataFitBef.rotation = photoContainer.rotation;
      this.targetDataFitBef.pos = { x: photoContainer.x, y: photoContainer.y };
      this.targetDataFitBef.scale = { x: photoContainer.scaleX, y: photoContainer.scaleY };
      this.targetDataFitBef.reg = { x: photoContainer.regX, y: photoContainer.regY };
      this.prevRotate = photoContainer.rotation;
    } else if (focusMode === 'png') {
      container = target;
      const containerData = container.getBounds();
      pointA = { x: target.regX - containerData.width / 2 + target.movePos.x, y: 0 };
      pointB = {
        x: target.regX - containerData.width / 2 + target.movePos.x,
        y: target.regY - containerData.height / 2 + target.movePos.y,
      };
      pointC = { x: mouseX, y: mouseY };
      // --- Redo用移動前座標の保持 ---
      this.targetData.rotation = target.rotation;
      this.targetData.pos = { x: target.x, y: target.y };
      this.targetData.scale = { x: target.scaleX, y: target.scaleY };
      this.targetData.reg = { x: target.regX, y: target.regY };
      this.targetDataFitBef.rotation = target.rotation;
      this.targetDataFitBef.pos = { x: target.x, y: target.y };
      this.targetDataFitBef.scale = { x: target.scaleX, y: target.scaleY };
      this.targetDataFitBef.reg = { x: target.regX, y: target.regY };
      this.prevRotate = target.rotation;
    } else {
      container = TrimCjTool.getScaleContainer(target);
      const containerData = container.getBounds();
      area = TrimCjTool.getImageAreaContainer(target);
      pointA = { x: containerData.x + containerData.width / 2 + area.movePos.x, y: containerData.y + area.movePos.y };
      pointB = {
        x: containerData.x + containerData.width / 2 + area.movePos.x,
        y: containerData.y + containerData.height / 2 + area.movePos.y,
      };
      pointC = { x: mouseX, y: mouseY };

      // --- Redo用移動前座標の保持 ---
      this.targetData.pos = { x: container.x, y: container.y };
      this.targetData.scale = { x: container.scaleX, y: container.scaleY };
      this.targetData.reg = { x: container.regX, y: container.regY };
      this.targetDataFitBef.pos = { x: container.x, y: container.y };
      this.targetDataFitBef.scale = { x: container.scaleX, y: container.scaleY };
      this.targetDataFitBef.reg = { x: container.regX, y: container.regY };
    }
    const radianA = Math.atan2(pointA.x - pointB.x, pointA.y - pointB.y);
    const radianB = Math.atan2(pointC.x - pointB.x, pointC.y - pointB.y);
    const angle = (radianA - radianB) / Math.PI * 180;
    // --- 角度からクリックされたコーナーを特定 ---
    if (angle >= 0 && angle < 90) {
      this.cornerType = 'rt';
    } else if (angle >= 90 && angle < 180) {
      this.cornerType = 'rb';
    } else if (angle >= 180 && angle < 270) {
      this.cornerType = 'lb';
    } else if (angle >= 270 && angle < 360) {
      this.cornerType = 'lt';
    }
    // --- png画像時の原点ずれによるコーナ情報のずれを抑制 ---
    if (focusMode === 'png') {
      const targetCorner = e.target.position;
      const targetAngle = target.rotation < 0 ? target.rotation + 360 : target.rotation % 360;
      switch (targetCorner) {
        case 'rt':
          if (targetAngle >= 315 || (targetAngle >= 0 && targetAngle < 45)) {
            this.cornerType = 'rt';
          } else if (targetAngle >= 45 && targetAngle < 135) {
            this.cornerType = 'rb';
          } else if (targetAngle >= 135 && targetAngle < 225) {
            this.cornerType = 'lb';
          } else if (targetAngle >= 225 && targetAngle < 315) {
            this.cornerType = 'lt';
          }
          break;
        case 'lb':
          if (targetAngle >= 315 || (targetAngle >= 0 && targetAngle < 45)) {
            this.cornerType = 'lb';
          } else if (targetAngle >= 45 && targetAngle < 135) {
            this.cornerType = 'lt';
          } else if (targetAngle >= 135 && targetAngle < 225) {
            this.cornerType = 'rt';
          } else if (targetAngle >= 225 && targetAngle < 315) {
            this.cornerType = 'rb';
          }
          break;
        default:
          break;
      }
    }
  }

  // -- containerの拡縮処理 --
  handleScaleMove(target: TrimCjContainer, e: any) {
    this.checkCounter++;
    const focusMode = this.trimDataManager.getFocusMode();
    const isPng = focusMode === 'png';
    const imageArea = !isPng ? TrimCjTool.getImageAreaContainer(target) : target;
    const scaleContainer = !isPng ? TrimCjTool.getScaleContainer(imageArea) : target;
    let container;
    if (focusMode === 'rotate' || focusMode === 'dai') {
      container = TrimCjTool.getPhotoContainer(target);
    } else if (focusMode === 'png') {
      container = target;
    } else {
      container = TrimCjTool.getScaleContainer(target);
    }
    const mouseX = Math.round(e.stageX - TrimImageEditManager.STAGE_CONTAINER_X);
    const mouseY = Math.round(e.stageY - TrimImageEditManager.STAGE_CONTAINER_Y);
    const data = container.getTransformedBounds();
    const difX = (mouseX - this.dragPointX);
    const difY = (mouseY - this.dragPointY);
    const sizeX = container.originalBounds.width * (focusMode === 'rotate' || focusMode === 'dai' ? scaleContainer.scaleX : 1);
    const sizeY = container.originalBounds.height * (focusMode === 'rotate' || focusMode === 'dai' ? scaleContainer.scaleY : 1);
    let scaleX;
    let scaleY;
    switch (this.cornerType) {
      case 'lt':
        scaleX = (((sizeX * this.targetData.scale.x) + (difX * -2))) / sizeX;
        scaleY = (((sizeY * this.targetData.scale.y) + (difY * -2))) / sizeY;
        break;
      case 'rt':
        scaleX = (((sizeX * this.targetData.scale.x) + (difX * 2))) / sizeX;
        scaleY = (((sizeY * this.targetData.scale.y) + (difY * -2))) / sizeY;
        break;
      case 'rb':
        scaleX = (((sizeX * this.targetData.scale.x) + (difX * 2))) / sizeX;
        scaleY = (((sizeY * this.targetData.scale.y) + (difY * 2))) / sizeY;
        break;
      case 'lb':
        scaleX = (((sizeX * this.targetData.scale.x) + (difX * -2))) / sizeX;
        scaleY = (((sizeY * this.targetData.scale.y) + (difY * 2))) / sizeY;
        break;
      default:
        scaleX = this.targetData.scale.x;
        scaleY = this.targetData.scale.y;
        break;
    }
    let scale = scaleX > scaleY ? scaleX : scaleY;

    // 20%~400%の間でscaling
    const scaleMin = (imageArea.logoFlag && !target.logoFlag) ? (imageArea.initResizeScale ?? 1) * 0.2 : 0.2;
    const scaleMax = (imageArea.logoFlag && !target.logoFlag) ? (imageArea.initResizeScale ?? 1) * 4 : 4;
    if (scale < scaleMin) {
      scale = scaleMin;
    } else if (scale > scaleMax) {
      scale = scaleMax;
    }
    const corners = focusMode === 'png'
      ? TrimCjTool.getCorner(container, true)
      : TrimCjTool.getCorner(container);
    for (const corner of corners) {
      const cornerScale = corner.parent.parent.name === 'photo-container'
        ? 1 / scale / scaleContainer.scaleX
        : target.name === 'photo-container'
          ? corner.scaleX
          : 1 / scale;
      corner.scaleX = cornerScale;
      corner.scaleY = cornerScale;
    }
    if (focusMode === 'png') {
      const deleteBtn = TrimCjTool.getFocusDeleteBtn(container);
      const deleteBtnScale = deleteBtn.parent.parent.name === 'photo-container'
        ? 1 / scale / scaleContainer.scaleX
        : target.name === 'photo-container'
          ? deleteBtn.scaleX
          : 1 / scale;
      deleteBtn.scaleX = deleteBtnScale;
      deleteBtn.scaleY = deleteBtnScale;
    }
    const prevScale = container.scaleX;
    container.set({
      scaleX: Math.round(scale * 100) / 100,
      scaleY: Math.round(scale * 100) / 100,
    });

    if (focusMode === 'rotate' || focusMode === 'dai') {
      if (!TrimCjTool.checkPhotoInFrame(target)) return;
      const photo = TrimCjTool.getPhotoContainer(target);
      // if (!(this.checkCounter % this.delayNum)) {
        const isToast = FitChecker.checkImageOneOutBounds(photo, !this.imageEditManager.printMenu.isAllowMargin);
      if (this.imageEditManager.printMenu.isAllowMargin) {
        this.imageEditManager.isFit = isToast;
        TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
      }
      if (isToast && !this.imageEditManager.printMenu.isAllowMargin) {
        const _scale = FitChecker.findClosestValidScale(container, prevScale, scale);
        container.set({
          scaleX: Math.round(_scale * 100) / 100,
          scaleY: Math.round(_scale * 100) / 100,
        });
        this.dragPointX = Math.round(mouseX);
        this.dragPointY = Math.round(mouseY);
        this.targetData.scale = { x: Math.round(_scale * 100) / 100, y: Math.round(_scale * 100) / 100 };
      }
      // }
    }
  }

  handleRotateMove(target: TrimCjContainer, e: any, moveTo: CornerType) {
    const focusMode = this.trimDataManager.getFocusMode();
    this.checkCounter++;
    const container = focusMode === 'rotate'
      ? TrimCjTool.getPhotoContainer(target)
      : target;
    const containerData = container.getBounds();
    const mouseX = Math.round(e.stageX - TrimImageEditManager.STAGE_CONTAINER_X);
    const mouseY = Math.round(e.stageY - TrimImageEditManager.STAGE_CONTAINER_Y);
    // --- A:ドラッグ起点 B：画像の中心 C：現在のマウス地点 ---
    let pointA;
    let pointB;
    const pointC = { x: mouseX, y: mouseY };

    if (focusMode === 'rotate' || focusMode === 'dai') {
      const area = TrimCjTool.getImageAreaContainer(target);
      const areaData = area.getBounds();
      pointA = { x: this.dragPointX, y: this.dragPointY };
      pointB = {
        x: areaData.x + areaData.width / 2 + container.movePos.x + area.movePos.x,
        y: areaData.y + areaData.height / 2 + container.movePos.y + area.movePos.y,
      };
    } else {
      pointA = { x: this.dragPointX, y: this.dragPointY };
      pointB = focusMode === 'png'
        ? {
          x: containerData.x + container.movePos.x,
          y: containerData.y + container.movePos.y,
        }
        : {
          x: containerData.x + containerData.width / 2 + container.movePos.x,
          y: containerData.y + containerData.height / 2 + container.movePos.y,
        };
    }
    const radianA = Math.atan2(pointA.x - pointB.x, pointA.y - pointB.y);
    const radianB = Math.atan2(pointC.x - pointB.x, pointC.y - pointB.y);
    const angle = (radianA - radianB) / Math.PI * 180;
    const nextRotate = this.targetData.rotation + angle;
    this.prevRotate = container.rotation;
    container.rotation = 0 > nextRotate ? 360 + nextRotate : nextRotate;

    if (focusMode === 'rotate' || focusMode === 'dai') {
      const isToast = FitChecker.checkImageOneOutBounds(container, !this.imageEditManager.printMenu.isAllowMargin);
      if (this.imageEditManager.printMenu.isAllowMargin) {
        this.imageEditManager.isFit = isToast;
        TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
      }
      if (isToast && !this.imageEditManager.printMenu.isAllowMargin) {
        const _rotate = FitChecker.findClosestValidRotation(container, this.prevRotate, nextRotate);
        container.rotation = _rotate;
        this.dragPointX = Math.round(mouseX);
        this.dragPointY = Math.round(mouseY);
        this.targetData.rotation = _rotate;
      }
    };

  }


  // -- containerの拡縮end --
  handleTransformEnd(target: TrimCjContainer, e: any) {
    this.checkCounter = 0;
    const photo = TrimCjTool.getPhotoContainer(target);
    // if (!(this.checkCounter % this.delayNum)) {
    const isToast = FitChecker.checkImageOneOutBounds(photo, !this.imageEditManager.printMenu.isAllowMargin);
    if (isToast && !this.imageEditManager.printMenu.isAllowMargin) {
      const _scale = FitChecker.findClosestValidScale(target, target.defaultScale, target.scaleX);
      target.set({
        scaleX: Math.round(_scale * 100) / 100,
        scaleY: Math.round(_scale * 100) / 100,
      });
      this.targetData.scale = { x: Math.round(_scale * 100) / 100, y: Math.round(_scale * 100) / 100 };
      const _rotate = FitChecker.findClosestValidRotation(target, this.prevRotate, target.rotation);
      target.rotation = _rotate;
      this.targetData.rotation = _rotate;
    }
    const ratio = (_corner: TrimCjCorner) => _corner.parent.parent.name === 'photo-container' ? TrimCjTool.getImageAreaContainer(target).scaleX : 1;
    console.log(this.targetDataFitBef);
    const focusMode = this.trimDataManager.getFocusMode();
    if (focusMode === 'rotate' || focusMode === 'png' || focusMode === 'dai') {
      const photoContainer = (focusMode === 'rotate' || focusMode === 'dai')
        ? TrimCjTool.getPhotoContainer(target)
        : target;
      // --- Redo ---
      const rotateBef = Math.round(this.targetDataFitBef.rotation * 100) / 100;
      const scaleBef = Math.round(this.targetDataFitBef.scale.x * 100) / 100;
      // --- Undo ---
      const rotateAf = Math.round(photoContainer.rotation * 100) / 100;
      const scaleAf = Math.round(photoContainer.scaleX * 100) / 100;
      const prevBase = (focusMode === 'rotate' || focusMode === 'dai')
        ? TrimCjTool.getDefaultContainer(target)
        : target;
      // --- fire ---
      this.editableEvent.action(
        'transform',
        `${rotateBef}から${rotateAf}度まで回転。${scaleBef}から${scaleAf}倍まで拡縮。`,
        () => {
          let prevTarget;
          if (!this.isFocus) {
            const isPng = focusMode === 'png';
            this.imageEditableTool.imageMode(prevBase, isPng);
          }
          prevTarget = (focusMode === 'rotate' || focusMode === 'dai')
            ? TrimCjTool.getPhotoContainer(prevBase)
            : prevBase;
          prevTarget.rotation = rotateAf;
          prevTarget.scaleX = scaleAf;
          prevTarget.scaleY = scaleAf;
          prevTarget.addDifferPos.x = prevTarget.originalBounds.width * scaleAf - prevTarget.virtual.width;
          prevTarget.addDifferPos.y = prevTarget.originalBounds.height * scaleAf - prevTarget.virtual.height;
          if (!(this.checkCounter % this.delayNum) && focusMode !== 'png') {
            const isToast = FitChecker.checkImageOneOutBounds(prevTarget);
            this.imageEditManager.isFit = isToast;
            TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
          }
          // this.layoutDataManager.dispatch('setScale', prevTarget);
        },
        () => {
          if (!this.isFocus) {
            const isPng = focusMode === 'png';
            this.imageEditableTool.imageMode(prevBase, isPng);
          }
          let prevTarget;
          prevTarget = (focusMode === 'rotate' || focusMode === 'dai')
            ? TrimCjTool.getPhotoContainer(prevBase)
            : prevBase;
          prevTarget.rotation = rotateBef;
          prevTarget.scaleX = scaleBef;
          prevTarget.scaleY = scaleBef;
          prevTarget.addDifferPos.x = prevTarget.originalBounds.width / scaleAf - prevTarget.virtual.width;
          prevTarget.addDifferPos.y = prevTarget.originalBounds.height / scaleAf - prevTarget.virtual.height;
          if (!(this.checkCounter % this.delayNum) && focusMode !== 'png') {
            const isToast = FitChecker.checkImageOneOutBounds(prevTarget);
            this.imageEditManager.isFit = isToast;
            TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
          }
          // this.layoutDataManager.dispatch('setScale', prevTarget);
        },
      );
    } else {
      const scaleContainer = TrimCjTool.getScaleContainer(target);
      const corners = TrimCjTool.getCorner(scaleContainer);
      // --- Redo ---
      const scaleBef = this.targetDataFitBef.scale.x;
      // --- Undo ---
      const scaleAf = scaleContainer.scaleX;
      // --- fire ---
      this.editableEvent.action(
        'scale',
        `${scaleBef}から${scaleAf}倍まで拡縮。`,
        () => {
          scaleContainer.scaleX = scaleAf;
          scaleContainer.scaleY = scaleAf;
          for (const corner of corners) {
            const cornerScaleAf = 1 / (scaleContainer.scaleX * ratio(corner));
            corner.scaleX = cornerScaleAf;
            corner.scaleY = cornerScaleAf;
          }
          // this.layoutDataManager.dispatch('setScale', scaleContainer);
        },
        () => {
          scaleContainer.scaleX = scaleBef;
          scaleContainer.scaleY = scaleBef;
          for (const corner of corners) {
            const cornerScaleBef = 1 / (this.targetData.scale.x * ratio(corner));
            corner.scaleX = cornerScaleBef;
            corner.scaleY = cornerScaleBef;
          }
          // this.layoutDataManager.dispatch('setScale', scaleContainer);
        },
      );
      // this.imageEditableTool.frameMode(target);
    }
    this.updateToolPos(focusMode, target);
    this.transformed = false;
  }

  // マウスオーバーのイベント（ツールチップ表示）
  mouseOverEvent(e: MouseEvent, image: TrimCjContainer) {
    let defaultPos = { x: this.stage.stage.mouseX, y: this.stage.stage.mouseY };
    this.timerId = setInterval(() => {
      if (defaultPos.x === this.stage.stage.mouseX
        && defaultPos.y === this.stage.stage.mouseY) {
        if (this.showToolTip) return;
        this.showToolTip = true;
        const photo = TrimCjTool.checkPhotoInFrame(e.currentTarget as TrimCjContainer);
        const pos = this.posManager.canvasToBrowser({
          // container の外側の座標だから container の座標を引いとく
          x: this.stage.stage.mouseX - TrimImageEditManager.STAGE_CONTAINER_X + 10,
          y: this.stage.stage.mouseY - TrimImageEditManager.STAGE_CONTAINER_Y + 10,
        });
        if (photo && !this.activeFocus && this.isSelect) {
          TrimUiManager.ins.emit('t->r:show-tooltip', {
            type: 'imageHover',
            pos,
          });
        }
      } else {
        this.showToolTip = false;
        defaultPos = { x: this.stage.stage.mouseX, y: this.stage.stage.mouseY };
        const photo = TrimCjTool.checkPhotoInFrame(image);
        if (photo && !this.activeFocus) {
          TrimUiManager.ins.emit('t->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
        }
      }
    }, 300);
  }

  // マウスアウトのイベント（ツールチップ表示）
  mouseOutEvent(e: MouseEvent, image: TrimCjContainer) {
    this.timerId && clearInterval(this.timerId);
    this.showToolTip = false;
    const photo = TrimCjTool.checkPhotoInFrame(image);
    if (photo && !this.activeFocus) {
      TrimUiManager.ins.emit('t->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
    }
  }

  // イメージのハンドラ設定
  setImageEvent(image: TrimCjContainer, type: 'frame' | 'image' | 'dai' | 'none', focus?: FocusModeType) {
    // if (type === 'dai') {
    //   const focusMode = this.layoutDataManager.selector('getFocusMode');
    //   image.on('click', (e: any) => {
    //     e.stopPropagation();
    //     this.trimmingManager.moveEnd();
    //     if (!this.isSelect) return;
    //     if (this.textEvent.isFocus) {
    //       this.textEvent.targetFrame && this.editableEvent.disFocused(this.textEvent.targetFrame);
    //       return;
    //     }
    //     if (this.clicked) {
    //       this.clicked = false;
    //       if (this.textEvent.isActive) return;
    //       const prevPhotoImage = TrimCjTool.checkPhotoInFrame(image);
    //       if (prevPhotoImage) {
    //         if ((focusMode === 'scale' || focusMode === 'DAI')) {
    //           this.imageEditableTool.imageMode(image, false, true);
    //           TrimUiManager.ins.emit('t->r:change-image/frame', { mode: 'image', isAdditional: true });
    //         }
    //       }
    //       return;
    //     }
    //     // --- シングルクリックの場合 ---
    //     this.clicked = true;
    //     // --- ダブルクリック受付時間 ---
    //     setTimeout(() => {
    //       // ---- ダブルクリックだとfalse ----
    //       if (this.clicked && focusMode !== 'rotate') {
    //         if (this.textEvent.isActive) return;
    //         TrimUiManager.ins.emit('t->r:change-middle-frame', { id: Number(image.photoAreaId) });
    //       }
    //       this.clicked = false;
    //     }, 250);
    //
    //   });
    // }
    if (type === 'image') {
      TrimCjTool.checkLoad(image).then((v) => {
        this.createFocus(v, focus ? focus : 'rotate')
          .then((container) => {
            container.visible = false;
            image.addChild(container);
          });
      });
      if (focus === 'png') {
        image.on('click', (e: any) => {
          e.stopPropagation();
          if (!this.isSelect || this.textEvent.isInsert) return;
          const corners = TrimCjTool.getCorner(image, true);
          const scale = 1 / image.scaleX;
          for (const corner of corners) {
            corner.scaleX = scale;
            corner.scaleY = scale;
          }
          const deleteBtn = TrimCjTool.getFocusDeleteBtn(image);
          deleteBtn.scaleX = scale;
          deleteBtn.scaleY = scale;
          this.imageEditableTool.imageMode(image, true);
          TrimUiManager.ins.emit('t->r:change-image/frame', { mode: 'image' });
        });
      }
    } else {
      const imageArea = TrimCjTool.getImageAreaContainer(image);
      if (type === 'frame') {
        TrimCjTool.checkLoad(imageArea).then((v) => {
          this.createFocus(v, 'scale')
            .then((container) => {
              container.visible = false;
              imageArea.addChild(container);
            });
          this.createFocus(v, 'move')
            .then((container) => {
              container.visible = false;
              imageArea.addChild(container);
            });
        });
        imageArea.removeAllEventListeners();
        // -- 枠の選択（フォーカスする） --
        imageArea.on('click', (e: any) => {
          e.stopPropagation();
          if (this.targetFrame) {
            this.editableEvent.disFocused(this.targetFrame, true);
            return;
          }
          if (this.textEvent.isInsert || this.panZoomManager.getOperationMode === 'pan-zoom') return;
          const _imageArea = TrimCjTool.getImageAreaContainer(image);
          const photoContainer = TrimCjTool.getPhotoContainer(image);
          const scaleContainer = TrimCjTool.getScaleContainer(_imageArea);
          const corners = TrimCjTool.getCorner(image);
          const ratio = (_target: TrimCjCorner | TrimCjShape) => _target.parent.parent.name === 'photo-container' ? scaleContainer.scaleX : 1;
          const parentScale = (_target: TrimCjCorner | TrimCjShape) => _target.parent.parent.name === 'photo-container' ? photoContainer.scaleX : scaleContainer.scaleX;

          for (const corner of corners) {
            const scale = 1 / parentScale(corner) / ratio(corner);
            corner.scaleX = scale;
            corner.scaleY = scale;
          }
          // const focusMode = this.layoutDataManager.selector('getFocusMode');
          if (!this.isSelect) return;
          // if (focusMode !== 'scale' || !this.isSelect) return;
          // --- ダブルクリックの場合 ---
          // if (this.clicked) {
          //   this.clicked = false;
            if (this.textEvent.isActive) return;
            const prevPhotoImage = TrimCjTool.checkPhotoInFrame(imageArea);
            if (prevPhotoImage) {
              // if (focusMode === 'scale' && (!this.targetFrame || this.targetFrame === imageArea)) {
              if ((!this.targetFrame || this.targetFrame === imageArea)) {
                this.imageEditableTool.imageMode(imageArea);
                // TrimUiManager.ins.emit('t->r:change-image/frame', { mode: 'image' });
              }
            }
            // return;
          // // --- シングルクリックの場合 ---
          // this.clicked = true;
          // TrimUiManager.ins.emit('t->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
          // // --- ダブルクリック受付時間 ---
          // setTimeout(() => {
          //   // ---- ダブルクリックだとfalse ----
          //   if (this.clicked) {
          //     if (this.textEvent.isActive) return;
          //     if (focusMode === 'scale' && !imageArea.logoFlag) {
          //       this.handleFocus(imageArea, 'scale');
          //     }
          //   }
          //   this.clicked = false;
          // }, 250);
        });

        // '「ダブルクリック」でトリミング'のツールチップ表示
        imageArea.addEventListener('mouseover', (e: any) => this.mouseOverEvent(e, image));
        imageArea.addEventListener('mouseout', (e: any) => this.mouseOutEvent(e, image));
      }
      // -- DnDイベント設定 --
      image.addEventListener('mousedown', (e: any) => {

        const focusMode = this.trimDataManager.getFocusMode();
        // if (focusMode === 'move') {
        //   this.handleMoveStart(image, e);
        //   return;
        // }
        const isPhoto = TrimCjTool.checkPhotoInFrame(image);
        if (this.clicked || focusMode === 'rotate' || !this.isSelect || this.isFocus || !isPhoto) return;
        if (focusMode === 'png' && this.targetFrame) {
          this.editableEvent.disFocused(this.targetFrame);
        }
        // this.handleMoveStart(image, e);
      }, true);
      image.addEventListener('pressmove', (e: any) => {
        const focusMode = this.trimDataManager.getFocusMode();
        // if (focusMode === 'move') {
        //   this.handleMove(image, e);
        //   return;
        // }
        if (this.clicked || focusMode === 'rotate' || !this.isSelect || this.isFocus) return;
        if (focusMode === 'png' && this.targetFrame) {
          this.editableEvent.disFocused(this.targetFrame);
        }
        // this.handleMove(image, e);
      }, true);
      image.addEventListener('pressup', (e: any) => {
        const focusMode = this.trimDataManager.getFocusMode();
        // if (focusMode === 'move') {
        //   this.handleMoveEnd(image, e);
        //   return;
        // }
        if (focusMode === 'rotate' || !this.isSelect || this.isFocus) return;
        if (focusMode === 'png' && this.targetFrame) {
          this.editableEvent.disFocused(this.targetFrame);
        }
        // this.handleMoveEnd(image, e);
      }, true);
    }
  }
}
